import { useMutation, useQuery } from '@tanstack/react-query';
import api from './config';

export const useRegister = () => {
    return useMutation({
        mutationFn: async (payload) => {
            const { data } = await api.post('/users/register/', payload);
            return data;
        },
        onSuccess: (data) => {
            // Store tokens in localStorage
            localStorage.setItem('access_token', data.tokens.access);
            localStorage.setItem('refresh_token', data.tokens.refresh);
        },
    });
};

export const useLogin = () => {
    return useMutation({
        mutationFn: async (payload) => {
            const { data } = await api.post('/users/login/', payload);
            return data;
        },
        onSuccess: (data) => {
            localStorage.setItem('access_token', data.tokens.access);
            localStorage.setItem('refresh_token', data.tokens.refresh);
        },
    });
};

export const useUpdateProfile = () => {
    return useMutation({
        mutationFn: async (payload) => {
            const { data } = await api.patch('/users/me/update/', payload);
            return data;
        }
    });
};

export const useUserProfile = (username) => {
    return useQuery({
        queryKey: ['userProfile', username],
        queryFn: async () => {
            const { data } = await api.get(`/users/profile/${username}/`);
            return data;
        },
        enabled: !!username
    });
}; 